import React from 'react'
import { connect } from 'react-redux'
import { getDistanceUnit, getOfferBasedLereState } from 'selectors/recommendations'
import YmalStickyFooter, { Props as YmalStickyFooterProps } from '../StickyFooter/YmalStickyFooter'
import { getListName } from 'analytics/enhanced-ecommerce'
import useLoadOfferBasedLereRecommendations from 'components/Recommendations/YouMayAlsoLike/Offer/hooks/useLoadOfferBasedLereRecommendations'
import { useTimePassed } from 'hooks/useTimePassed'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import getOfferListKey from 'lib/offer/offerListKey'

interface Props extends Omit<YmalStickyFooterProps, 'animationSpeed' | 'hidden'> {
  seedOffer: App.Offer | App.BedbankOffer
  show: boolean
  initialShowDelayMs?: number
  hideImmediately?: boolean
  pageSource: string
}

function OfferYmalStickyFooter({ pageSource, show, hideImmediately, initialShowDelayMs, ...passOnProps }: Props) {
  const {
    seedOffer,
    filters,
  } = passOnProps

  const { checkIn, checkOut, rooms } = filters ?? {}

  useLoadOfferBasedLereRecommendations(seedOffer.id, true, checkIn, checkOut, undefined, rooms)

  const animationSpeed = hideImmediately ? 'immediate' : 'gradual'

  const delayPassed = useTimePassed(initialShowDelayMs)
  const hidden = !!hideImmediately || !delayPassed || !show

  const tracking = useOfferListTracking(
    getListName('LERE', pageSource, 'Sticky Footer'),
    { key: filters ? getOfferListKey(filters) : undefined },
  )

  const footerProps: YmalStickyFooterProps = {
    ...passOnProps,
    hidden,
    animationSpeed,
  }

  return (
    <OfferListEventsProvider tracking={tracking}>
      <YmalStickyFooter
        {...footerProps}
      />
    </OfferListEventsProvider>
  )
}

function mapState(state: App.State, ownProps: Partial<Props>) {
  const { seedOffer } = ownProps
  const offerBasedLereState = getOfferBasedLereState(
    state,
    seedOffer!,
  )

  return {
    offerIds: offerBasedLereState.offerIds,
    currency: state.geo.currentCurrency,
    distanceUnit: getDistanceUnit(state),
    loadingState: offerBasedLereState.loadingState,
    loadingError: offerBasedLereState.loadingError,
    hasEnoughRecommendationsToDisplay: offerBasedLereState.hasEnoughRecommendationsToDisplay,
  }
}

export default connect(mapState)(OfferYmalStickyFooter)
